import { getDirectusClient } from "../lib/directus";
import { readItems } from "@directus/sdk";
const directus = getDirectusClient();

export const getProductos = async () => {
  const response = await directus.request(
    readItems("productos", {
      fields: ["*", "grupo.nombre","grupo.id", "estado.nombre", "estado.id", "precios.precio", "precios.alias"],
      sort: "-date_created",
      limit: -1,
    })
  );    
  return response;
};
export const getProductosCount = async () => {
    const response = await directus.request(
      readItems("productos", {
        fields: ["*", "grupo.nombre","grupo.id", "estado.nombre", "estado.id", "precios.precio", "precios.alias"],
        sort: "-date_created",
        limit: -1,
        aggregate: {
          countDistinct: ["id"],
        },
      })
    );
    return response;
  };
  export const getProductosCountByNombre = async (nombre) => {
      const response = await directus.request(
        readItems("productos", {
          fields: ["*", "grupo.nombre","grupo.id", "estado.nombre", "estado.id", "precios.precio", "precios.alias"],
          sort: "-date_created",
          limit: -1,
          aggregate: {
            countDistinct: ["id"],
          },
          filter: {
            nombre: {
              _contains: nombre,
            },
          },
        })
      );
      return response;
    };
  
  export const getProductosByNombre = async (nombre, page = 1, limit = -1) => {
    try {
      const response = await directus.request(
        readItems("productos", {
            fields: ["*", "grupo.nombre","grupo.id", "estado.nombre", "estado.id", "precios.precio", "precios.alias"],
            sort: "-date_created",
          filter: {
            _and: [
              {
                nombre: {
                  _contains: nombre,
                },
              },
            ],
          },
          page: page,
          limit: limit,
        })
      );
      return response;
    } catch (error) {
      throw error;
    }
  };
  export const getProductosNoSerializados = async (page = 1, limit = -1) => {
    try {
      const response = await directus.request(
        readItems("productos", {
          fields: ["*", "grupo.nombre", "grupo.id", "estado.nombre", "estado.id", "precios.precio", "precios.alias"],
          sort: "-date_created",
          filter: {
            _and: [
              {
                grupo: {
                  codebar: {
                    _eq: false
                  }
                }
              }
            ]
          },
          page: page,
          limit: limit,
        })
      );
      return response;
    } catch (error) {
      throw error;
    }
  };

export const getProductosActivos = async () => {
  try {
    const response = await directus.request(
      readItems("productos", {
        fields: [
          "*",
          "grupo.nombre",
          "grupo.id",
          "grupo.impuesto",
          "estado.nombre",
          "estado.id",
          "precios.precio",
          "precios.alias",
          "seriales.id",
          "seriales.estado.id",
          "seriales.estado.nombre"
        ],
        filter: {
          _and: [
            {
              estado: {
                id: { _eq: 1 }
              }
            }
          ]
        },
        sort: "-date_created",
        limit: -1,
      })
    );

    // Filtrar productos que tienen seriales activos o son no serializados
    const productosFiltrados = response.filter(producto => {
      // Si el producto no tiene seriales, es no serializado
      if (!producto.seriales || producto.seriales.length === 0) {
        return true;
      }
      
      // Si tiene seriales, verificar si tiene al menos uno activo
      return producto.seriales.some(serial => serial.estado?.id === 1);
    });

    return productosFiltrados;
  } catch (error) {
    console.error("Error fetching active products:", error);
    throw error;
  }
};